const localizedPaths = {
  en: 'media-switzerland',
  de: 'medien-schweiz',
  fr: 'presse-suisse',
};
/**
 * @param locale fr,de,en
 * @returns a subdirectory name depending which locale is selected
 * This method is strictly necessary for Switzerland media releases
 */
export const getLocalizedDetailedPagePath = (locale: string): string => localizedPaths[locale] || '';
